export const USE_BU_ORG_CODE = "useBuOrgCode";
export const PATH_PARAMETERS_CONFIGURATIONS = "/parameters/configurations";
export const PATH_PARAMETERS_CONFIGURATIONS_UID = `${PATH_PARAMETERS_CONFIGURATIONS}/:uid`;
